import React from 'react';
import { Link } from 'react-router-dom';
import Reveal from '../../../shared/Reveal/Reveal';
import { useSolutionsTailoredStrategiesContent } from '../../../../hooks/useSolutionsTailoredStrategiesContent';
import './TailoredStrategies.css';

const renderMultilineText = (text) =>
  text.split('\n').map((line, index, lines) => (
    <React.Fragment key={`${line}-${index}`}>
      {line}
      {index < lines.length - 1 ? <br /> : null}
    </React.Fragment>
  ));

const TailoredStrategies = () => {
  const { content, isLoading } = useSolutionsTailoredStrategiesContent();

  if (isLoading || !content) {
    return null;
  }

  const { title, text, cta, features, featureImage, checkIcon } = content;

  return (
    <section className="tailored-strategies">
      <Reveal className="tailored-strategies__copy">
        <div className="tailored-strategies__copy-inner">
          <h2 className="tailored-strategies__title">{renderMultilineText(title)}</h2>
          {text ? <p className="tailored-strategies__text">{text}</p> : null}

          <ul className="tailored-strategies__list">
            {features.map((feature) => (
              <li key={feature} className="tailored-strategies__item">
                <img
                  className="tailored-strategies__check"
                  src={checkIcon}
                  alt=""
                  aria-hidden="true"
                />
                {feature}
              </li>
            ))}
          </ul>

          {cta?.text && cta?.url ? (
            <Link to={cta.url} className="tailored-strategies__cta luxury-btn">
              {cta.text}
            </Link>
          ) : null}
        </div>
      </Reveal>

      <Reveal className="tailored-strategies__media" delay={80}>
        <img
          className="tailored-strategies__image"
          src={featureImage}
          alt=""
          aria-hidden="true"
        />
      </Reveal>
    </section>
  );
};

export default TailoredStrategies;
